module.exports = __webpack_public_path__ + "static/media/ic_calendar-primary.463bdad1.svg";